export default "__VITE_ASSET__DpdmBTFi__"